import { UnifiedPerson } from 'CitizenProfile/types'
import { Dispatch, SetStateAction, createContext } from 'react'
import { User } from 'UnifiedLogin/types'

type AuthenticationContextType = {
  user: User | null
  userBond: any
  userBondRequest: any
  setUserBondRequest: Dispatch<SetStateAction<any>>
  fillUser: (user: User | null) => void
  setUser: Dispatch<SetStateAction<User | null>>
  logout: () => Promise<string | boolean>
  unifiedPerson: UnifiedPerson | null
  setUnifiedPerson: Dispatch<SetStateAction<UnifiedPerson | null>>
}

const defaultValue = {
  user: {},
  userBond: {},
  userBondRequest: {},
  setUserBondRequest: () => {},
  fillUser: () => {},
  setUser: () => {},
  logout: async () => '',
  unifiedPerson: {},
  setUnifiedPerson: () => {},
}

const AuthenticationContext = createContext<AuthenticationContextType>(defaultValue)

export default AuthenticationContext
